import { Component } from '@angular/core';

@Component({
  selector: 'polaris-error-stub',
  standalone: false,
  template: 'There was a problem loading this card',
})
export class ErrorComponent {}
